// Email validation
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Password validation
export const validatePassword = (password) => {
  const errors = [];

  if (password.length < 6) {
    errors.push("Password must be at least 6 characters long");
  }

  if (!/(?=.*[a-z])/.test(password)) {
    errors.push("Password must contain at least one lowercase letter");
  }

  if (!/(?=.*[A-Z])/.test(password)) {
    errors.push("Password must contain at least one uppercase letter");
  }

  if (!/(?=.*\d)/.test(password)) {
    errors.push("Password must contain at least one number");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

// Password confirmation validation
export const validatePasswordConfirmation = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return {
      isValid: false,
      error: "Passwords do not match",
    };
  }

  return {
    isValid: true,
    error: null,
  };
};

// Required field validation
export const validateRequiredFields = (data, fields) => {
  const missingFields = fields.filter(
    (field) => !data[field] || data[field].toString().trim() === "",
  );

  if (missingFields.length > 0) {
    return {
      isValid: false,
      errors: missingFields.map((field) => `${field} is required`),
    };
  }

  return {
    isValid: true,
    errors: [],
  };
};

// Form validation helper
export const validateForm = (data, validations) => {
  const errors = [];

  Object.entries(validations).forEach(([field, validator]) => {
    const value = data[field];
    const result = validator(value, data);

    if (!result.isValid) {
      if (Array.isArray(result.errors)) {
        errors.push(...result.errors);
      } else if (result.error) {
        errors.push(result.error);
      }
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export default {
  validateEmail,
  validatePassword,
  validatePasswordConfirmation,
  validateRequiredFields,
  validateForm,
};
